import React from 'react'

// UseEffect but it only runs on updates and not on mount
const useUpdateEffect: typeof React.useEffect = (effect, deps) => {
  const isMounted = React.useRef(false)

  React.useEffect(() => {
    if (isMounted.current) {
      return effect()
    }

    isMounted.current = true
    return undefined
  }, deps)
}

export default useUpdateEffect
